import { defineStore } from 'pinia'
import {services, getHeader } from '@/assets/js/config.js'
import axios from 'axios'

export const useLookupStore = defineStore('lookupStore', {
  state:() => ({
    banks: null,
		list_bank_statuses : [],
		list_mortgage_status : [],
		list_personal_loan_status : [],
		list_insurance_status : [],
		list_other_loan_status : [],
		list_lead_statuses : [],
    list_solicitor_status : [],
		list_channels : [],
		list_platforms : [],
		list_salutation : [],
		list_budget : [],
		list_property_type : [],
		list_location : [],
		list_income_type : [],
    advisoryStatusList: [],
  }),
	getters: {
		list_sub_bank_status(){
			return this.list_bank_statuses
		},
		list_main_mortgage_status(){
			return this.list_mortgage_status.filter((item) => item.group === 'main')
		},
		list_sub_mortgage_status(){
			return this.list_mortgage_status.filter((item) => item.group === 'sub')
		},
		list_main_personal_loan_status(){
			return this.list_personal_loan_status.filter((item) => item.group === 'main')
		},
		list_sub_personal_loan_status(){
			return this.list_personal_loan_status.filter((item) => item.group === 'sub')
		},
		list_main_insurance_status(){
			return this.list_insurance_status.filter((item) => item.group === 'main')
		},
		list_sub_insurance_status(){
			return this.list_insurance_status.filter((item) => item.group === 'sub')
		},
		list_main_other_loan_status(){
			return this.list_other_loan_status.filter((item) => item.group === 'main')
		},
		list_sub_other_loan_status(){
			return this.list_other_loan_status.filter((item) => item.group === 'sub')
		},
    list_main_solicitor_status(){
			return this.list_solicitor_status.filter((item) => item.group === 'main')
		},
		list_sub_solicitor_status(){
			return this.list_solicitor_status.filter((item) => item.group === 'sub')
		}
	},
	actions : {
		initConstant(){
			this.getBanks();
			this.getCaseStatusList('bank_statuses').then(resp => {
				this.list_bank_statuses = resp;
			});
			this.getCaseStatusList('mortgage_status').then(resp => {
				this.list_mortgage_status = resp;
			});
			this.getCaseStatusList('personal_loan_status').then(resp => {
				this.list_personal_loan_status = resp;
			});
			this.getCaseStatusList('insurance_status').then(resp => {
				this.list_insurance_status = resp;
			});
			this.getCaseStatusList('other_loan_status').then(resp => {
				this.list_other_loan_status = resp;
			});
      this.getCaseStatusList('solicitor_status').then(resp => {
				this.list_solicitor_status = resp;
			});
			this.getLeadStatuses().then(resp => {
				this.list_lead_statuses = _gHlp.getValue(resp,'data');
			});
			// this.getSalutations({paginate:'no_paginate'}).then(resp => {
			// 	this.list_salutation = _gHlp.getValue(resp,'data');
			// });
			// this.getBudgets({paginate:'no_paginate'}).then(resp => {
			// 	this.list_budget = _gHlp.getValue(resp,'data');
			// });
			// this.getPropertyTypes({ paginate: 'no_paginate'}).then(resp => {
			// 	this.list_property_type = _gHlp.getValue(resp,'data');
			// });
			// this.getLocations({ paginate: 'no_paginate' }).then(resp => {
			// 	this.list_location = _gHlp.getValue(resp,'data');
			// });
			this.getChannels().then(resp => {
				this.list_channels = _gHlp.getValue(resp,'data');
			});
			this.getPlatforms().then(resp => {
				this.list_platforms = _gHlp.getValue(resp,'data');
			});
			this.getLookupTables(['income_types']).then(resp =>{
				this.list_income_type = _gHlp.getValue(resp,'income_types',[]);
			});
		},
    async deleteAdvisoryStatus(status_id) {
      try {
        await axios.delete(services.lookup + 'loan_advisory_status/' + status_id, {headers: getHeader()});
      } catch (error) {
        console.error('Error deleting advisory status:', error);
      }
    },
    getAdvisoryStatus(params={}){
      this.advisoryStatusList  = [];
      return new Promise((resolve, reject) => {
        let strParams = _gHlp.generateQueryParams(params);
        axios.get(services.lookup + 'loan_advisory_status? '+ strParams, {headers: getHeader()}).then((resp) => {
          this.advisoryStatusList = resp.data.data
        resolve(this.advisoryStatusList)
        }).catch(err => {
          reject(err)
        })
      })  
    },
    async createAdvisoryStatus(newStatus) {
      try {
        const form = new FormData();
        form.append('status', newStatus.status_name);
        form.append('group', newStatus.status_type);
        form.append('parent_id', newStatus.status_parent);
        form.append('tat_day', newStatus.tat_day);
        form.append('tat_stop', newStatus.tat_stop ? 1 : 0);

        const response = await axios.post(services.lookup + 'loan_advisory_status', form, { headers: getHeader() });
        return response.data;
      } catch (error) {
        console.error('Error creating advisory status:', error);
      }
    },
    async updateAdvisoryStatus(status_id, formData) {
      try {
        const response = await axios.put(services.lookup + 'loan_advisory_status/' + status_id , formData, { headers: getHeader() })
        return response.data;
      } catch (error) {
        console.error('Error updating advisory status:', error);
      }
    },
		async getBanks(){
			try{
					let formData = new FormData()
					formData.append('tables', ['banks'])
					const response = await axios.post(services.lookup + 'tables', formData, { headers: getHeader() })
					this.banks = (!_gHlp.isEmpty(response.data.data) && !_gHlp.isEmpty(response.data.data.banks)) ? response.data.data.banks : []
			}catch(e){
					// this.errorFunction(e)
					console.log(e)
			}
		},
		getLookupTables(tables){
			return new Promise((resolve, reject) => {
				let formData = new FormData()
				formData.append('tables', tables)

				axios.post(services.lookup + 'tables', formData, { headers: getHeader() }).then(resp => {
					resolve(_gHlp.getValue(resp,'data.data',[]));
				}).catch(err => {
					reject(err);
				});
			})
		},
		getCaseStatusList(table_name){
			return new Promise((resolve, reject) => {
				if(table_name == 'bank_statuses'){
					let formData = new FormData()
					formData.append('tables', ['bank_statuses'])
					axios.post(services.lookup + 'tables', formData, { headers: getHeader() }).then(resp => {
						resolve(_gHlp.getValue(resp,'data.data.bank_statuses',[]));
					}).catch(err => {
						reject(err);
					});
				}else{
					axios.get(services.lookup + table_name, { headers: getHeader() }).then(resp => {
						resolve(_gHlp.getValue(resp,'data.data',[]));
					}).catch(err => {
						reject(err);
					});
				}
			})
		},
		getLeadStatuses(params={}){
			return new Promise((resolve, reject) => {
				let reqParams = _gHlp.generateQueryParams(params);
				axios.get(services.lookup + 'status?'+reqParams, { headers: getHeader() }).then(resp => {
					resolve(_gHlp.getValue(resp,'data',[]));
				}).catch(err => {
					reject(err);
				})
			})
		},
		async createLeadStatus(params){
			try{
				const response = await axios.post(services.lookup + 'status', params, { headers: getHeader()})
				return response;
			}catch(e){
				_gNotif.errorFunction(e);
				return [];	
			}
		},
		async updateLeadStatus(id,params){
			try{
				const response = await axios.put(services.lookup + 'status/'+id, params, { headers: getHeader()})
				return response;
			}catch(e){
				_gNotif.errorFunction(e);
				return [];	
			}
		},
		async deleteLeadStatus(id){
			try{
				const response = await axios.delete(services.lookup + 'status/'+id, { headers: getHeader()})
				return response;
			}catch(e){
				_gNotif.errorFunction(e);
				return [];	
			}
		},
		getChannels(params={}){
			return new Promise((resolve, reject) => {
				let reqParams = _gHlp.generateQueryParams(params);
				axios.get(services.lookup + 'channel?'+reqParams, { headers: getHeader() }).then(resp => {
					resolve(_gHlp.getValue(resp,'data',[]));
				}).catch(err => {
					reject(err);
				})
			})
		},
		async createChannel(params){
			try{
				const response = await axios.post(services.lookup + 'channel', params, { headers: getHeader()})
				return response;
			}catch(e){
				_gNotif.errorFunction(e);
				return [];	
			}
		},
		async updateChannel(id,params){
			try{
				const response = await axios.put(services.lookup + 'channel/'+id, params, { headers: getHeader()})
				return response;
			}catch(e){
				_gNotif.errorFunction(e);
				return [];	
			}
		},
		async deleteChannel(id){
			try{
				const response = await axios.delete(services.lookup + 'channel/'+id, { headers: getHeader()})
				return response;
			}catch(e){
				_gNotif.errorFunction(e);
				return [];	
			}
		},
		getPlatforms(params={}){
			return new Promise((resolve, reject) => {
				let reqParams = _gHlp.generateQueryParams(params);
				axios.get(services.lookup + 'platform?'+reqParams, { headers: getHeader() }).then(resp => {
					resolve(_gHlp.getValue(resp,'data',[]));
				}).catch(err => {
					reject(err);
				})
			})
		},
		async createPlatform(params){
			try{
				const response = await axios.post(services.lookup + 'platform', params, { headers: getHeader()})
				return response;
			}catch(e){
				_gNotif.errorFunction(e);
				return [];	
			}
		},
		async updatePlatform(id,params){
			try{
				const response = await axios.put(services.lookup + 'platform/'+id, params, { headers: getHeader()})
				return response;
			}catch(e){
				_gNotif.errorFunction(e);
				return [];	
			}
		},
		async deletePlatform(id){
			try{
				const response = await axios.delete(services.lookup + 'platform/'+id, { headers: getHeader()})
				return response;
			}catch(e){
				_gNotif.errorFunction(e);
				return [];	
			}
		},
		getSalutations(params={}){
			return new Promise((resolve, reject) => {
				let reqParams = _gHlp.generateQueryParams(params);
				axios.get(services.lookup + 'salutation?'+reqParams, { headers: getHeader() }).then(resp => {
					resolve(_gHlp.getValue(resp,'data',[]));
				}).catch(err => {
					reject(err);
				})
			})
		},
		async createSalutation(params){
			try{
				const response = await axios.post(services.lookup + 'salutation', params, { headers: getHeader()})
				return response;
			}catch(e){
				_gNotif.errorFunction(e);
				return [];	
			}
		},
		async updateSalutation(id,params){
			try{
				const response = await axios.put(services.lookup + 'salutation/'+id, params, { headers: getHeader()})
				return response;
			}catch(e){
				_gNotif.errorFunction(e);
				return [];	
			}
		},
		async deleteSalutation(id){
			try{
				const response = await axios.delete(services.lookup + 'salutation/'+id, { headers: getHeader()})
				return response;
			}catch(e){
				_gNotif.errorFunction(e);
				return [];	
			}
		},
		getBudgets(params={}){
			return new Promise((resolve, reject) => {
				let reqParams = _gHlp.generateQueryParams(params);
				axios.get(services.lookup + 'budget?'+reqParams, { headers: getHeader() }).then(resp => {
					resolve(_gHlp.getValue(resp,'data',[]));
				}).catch(err => {
					reject(err);
				})
			})
		},
		async createBudget(params){
			try{
				const response = await axios.post(services.lookup + 'budget', params, { headers: getHeader()})
				return response;
			}catch(e){
				_gNotif.errorFunction(e);
				return [];	
			}
		},
		async updateBudget(id,params){
			try{
				const response = await axios.put(services.lookup + 'budget/'+id, params, { headers: getHeader()})
				return response;
			}catch(e){
				_gNotif.errorFunction(e);
				return [];	
			}
		},
		async deleteBudget(id){
			try{
				const response = await axios.delete(services.lookup + 'budget/'+id, { headers: getHeader()})
				return response;
			}catch(e){
				_gNotif.errorFunction(e);
				return [];	
			}
		},
		getPropertyTypes(params={}){
			return new Promise((resolve, reject) => {
				let reqParams = _gHlp.generateQueryParams(params);
				axios.get(services.lookup + 'property-type?'+reqParams, { headers: getHeader() }).then(resp => {
					resolve(_gHlp.getValue(resp,'data',[]));
				}).catch(err => {
					reject(err);
				})
			})
		},
		async createPropertyType(params){
			try{
				const response = await axios.post(services.lookup + 'property-type', params, { headers: getHeader()})
				return response;
			}catch(e){
				_gNotif.errorFunction(e);
				return [];	
			}
		},
		async updatePropertyType(id,params){
			try{
				const response = await axios.put(services.lookup + 'property-type/'+id, params, { headers: getHeader()})
				return response;
			}catch(e){
				_gNotif.errorFunction(e);
				return [];	
			}
		},
		async deletePropertyType(id){
			try{
				const response = await axios.delete(services.lookup + 'property-type/'+id, { headers: getHeader()})
				return response;
			}catch(e){
				_gNotif.errorFunction(e);
				return [];	
			}
		},
		getLocations(params={}){
			return new Promise((resolve, reject) => {
				let reqParams = _gHlp.generateQueryParams(params);
				axios.get(services.lookup + 'location?'+reqParams, { headers: getHeader() }).then(resp => {
					resolve(_gHlp.getValue(resp,'data',[]));
				}).catch(err => {
					reject(err);
				})
			})
		},
		async createLocation(params){
			try{
				const response = await axios.post(services.lookup + 'location', params, { headers: getHeader()})
				return response;
			}catch(e){
				_gNotif.errorFunction(e);
				return [];	
			}
		},
		async updateLocation(id,params){
			try{
				const response = await axios.put(services.lookup + 'location/'+id, params, { headers: getHeader()})
				return response;
			}catch(e){
				_gNotif.errorFunction(e);
				return [];	
			}
		},
		async deleteLocation(id){
			try{
				const response = await axios.delete(services.lookup + 'location/'+id, { headers: getHeader()})
				return response;
			}catch(e){
				_gNotif.errorFunction(e);
				return [];	
			}
		},
	   //Solicitor LA Status
     async getLaStatus(corporate_id = null) {
      try {
        const res = await axios.get(services.lookup + 'la-status', { headers: getHeader() ,
          params: { corporate_id }
        });
        this.laStatusLList = res.data.data
        return res.data.data;  // Return data directly
      } catch (e) {
        this.laStatusLList = []
        console.log('Get La Status failed:' + e.response.data.message)
      }
    },
     //Solicitor SPA Status
     async getSpaStatus(corporate_id = null) {
      try {
        const res = await axios.get(services.lookup + 'spa-status', { headers: getHeader() ,
          params: { corporate_id }
        });
        this.spaStatusLList = res.data.data
        return res.data.data;  // Return data directly
      } catch (e) {
        this.spaStatusLList = []
        console.log('Get Spa Status failed:' + e.response.data.message)
      }
    },
     //Solicitor Invoice Settings 
     async getInvoiceSettings() {
      try {
        const res = await axios.get(services.lookup + 'invoice-settings', { headers: getHeader() })
        this.invoiceSettingList = res.data.data
        return res.data.data;  // Return data directly

      } catch (e) {
        this.invoiceSettingLList = []
        console.log('Get Invoice Settings failed:' + e.response.data.message)
      }
    },
    //Solicitor Fees Charges

    async getFeesCharges(corporate_id = null) {
      try {
        const res = await axios.get(services.lookup + 'fees-charges', { 
          headers: getHeader(),
          params: { corporate_id }
        });
        // this.feesChargestList = res.data.data
        return res.data.data;  // Return data directly

      } catch (e) {
        this.feesChargesList = []
        console.log('Fees Charges failed:' + e.response.data.message)
      }
    },
    async getSolicitorStatus(corporate_id = null) {
      try {
        const res = await axios.get(services.lookup + 'solicitor_status', {
          headers: getHeader(),
          params: { corporate_id }
        });
        return res.data.data;  // Return data directly

      } catch (e) {
        console.log('Fees Charges failed:' + e.response.data.message)
      }
    },
  }
})

